import { initSession } from "./auth";
import "./style.scss";

document.addEventListener("DOMContentLoaded", initSession);
